import { Deposito, Loja, LojaDoPdv, Page, ParametrosControlPay } from '@/models'
import { Inject } from 'inversify-props'
import { LojaServiceAdapter } from '@/usecases'
import { AxiosRequestConfig } from 'axios'

export class FindLojaUseCase {
	@Inject('LojaServiceAdapter')
	private lojaService!: LojaServiceAdapter

	async findLojaById(id: string): Promise<Loja> {
		return this.lojaService.get(id)
	}

	async findLojaByPdv(id: string): Promise<Loja> {
		return this.lojaService.findLojaByPdv(id)
	}

	async findDepositoDaLojaById(id: string, params?: AxiosRequestConfig): Promise<Page<Deposito>> {
		return this.lojaService.getDepositoDaLoja(id, params)
	}

	find = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Loja>> =>
		await this.lojaService.find(params, config)

	buscarParametrosControlPay = async (lojaId: string): Promise<ParametrosControlPay> =>
		await this.lojaService.buscarParametrosControlPay(lojaId)

	findLojaDaTabela = async (tabelaId: string): Promise<Page<LojaDoPdv>> =>
		await this.lojaService.findLojaDaTabela(tabelaId)

	async findLojasVinculadasByLojaId(params?: any, config?: AxiosRequestConfig): Promise<Page<Loja>> {
		return this.lojaService.findLojasVinculadasByLojaId(params, config)
	}
}
